import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import TableComponent from "../../../shared/components/table";
import { PaymentHistoryColumns } from "../../../shared/components/table/columns/paymentHistory";
import { SortingState } from "@tanstack/react-table";
import { FILTER } from "../../../assets";
import PaymentReceiptModal from "./case-folder/modals/PaymentReceiptModal";

const TABS = ["All pending transactions", "All successful transactions"];
const MOCK_DATA = [
  {
    sn: false,
    date: "31-05-2024",
    amount: "₦2,235.00",
    status: "Paid",
    description: "Olugbenga Akintola vs Israel Anyemalu",
    payment: "VIEW Receipt",
  },
  {
    sn: false,
    date: "31-05-2024",
    amount: "₦3,635.00",
    status: "Paid",
    description: "Olugbenga Akintola vs Israel Anyemalu",
    payment: "VIEW Receipt",
  },
  {
    sn: false,
    date: "31-05-2024",
    amount: "₦2,235.00",
    status: "Paid",
    description: "Olugbenga Akintola vs Israel Anyemalu",
    payment: "VIEW Receipt",
  },
];

const FILTER_OPTIONS = [
  "All cases",
  "Pending cases",
  "Completed cases",
  "Archived cases",
];

function PaymentHistory() {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("All cases");
  const [openReceiptModal, setOpenReceiptModal] = useState(false);
  const [selectedReceiptData, setSelectedReceiptData] = useState<any>(null);
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const handleOpenReceipt = (data: any) => {
    setSelectedReceiptData(data);
    setOpenReceiptModal(true);
  };

  return (
    <div className="flex flex-col h-full min-h-screen ">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB] flex flex-col gap-y-4">
        <div className="flex items-center border-b border-[#E9EAEB] pb-3 justify-between">
          <h1 className="text-[28px] font-bold text-[#1A1A1A]">
            Payment history
          </h1>

          {/* Filter Dropdown */}
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="flex items-center gap-x-2 px-4 py-2 border border-[#D0D5DD] rounded-lg text-sm font-medium text-[#344054] hover:bg-gray-50 bg-white shadow-sm transition-colors">
              <img src={FILTER} alt="filter" className="w-4 h-4" />
              <span>{selectedFilter}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 py-1">
                <div className="px-1 py-1">
                  {FILTER_OPTIONS.map((option) => (
                    <Menu.Item key={option}>
                      {({ active }) => (
                        <button
                          onClick={() => setSelectedFilter(option)}
                          className={`${
                            active
                              ? "bg-gray-50 text-[#1A1A1A]"
                              : "text-[#344054]"
                          } group flex w-full items-center rounded-md px-3 py-2 text-sm font-medium`}
                        >
                          {option}
                        </button>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        <div className="flex items-center gap-x-2 text-sm text-[#475467]">
          <Link
            to="/lawyer/overview"
            className="hover:text-[#00B074] transition-colors"
          >
            Home
          </Link>
          <span className="text-[#D0D5DD]">{">"}</span>
          <span className="font-medium text-[#1A1A1A]">Payment history</span>
        </div>
      </div>
      <div className="px-8 pt-6 bg-white border-b border-[#E9EAEB]">
        <div className="flex items-center gap-x-8 overflow-x-auto scrollbar-hide">
          {TABS.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-4 text-sm font-medium transition-colors whitespace-nowrap relative ${
                activeTab === tab
                  ? "text-[#00B074]"
                  : "text-[#667085] hover:text-[#344054]"
              }`}
            >
              {tab}
              {activeTab === tab && (
                <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#00B074] rounded-t-sm" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="p-8 flex flex-col gap-y-6">
        {/* Search */}
        <div className="relative w-full max-w-[300px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] focus:ring-1 focus:ring-[#00B074] bg-white text-sm placeholder:text-[#667085] shadow-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#667085]" />
        </div>

        {/* Table */}
        <div className="bg-white overflow-hidden">
          <TableComponent
            DATA={MOCK_DATA}
            // @ts-ignore
            COLUMNS={PaymentHistoryColumns(handleOpenReceipt)}
            sorting={sorting}
            setSorting={setSorting}
          />

          {/* Pagination */}
          <div className="px-6 py-4 border-t border-[#E9EAEB] flex items-center justify-between">
            {/* Left side empty or could have selection info */}
            <div className="hidden sm:block"></div>

            <div className="flex items-center gap-x-6 w-full sm:w-auto justify-between sm:justify-end">
              <span className="text-sm text-[#344054] font-medium">
                Page 1 of 10
              </span>

              <div className="flex items-center gap-x-3">
                <button className="px-3 py-2 border border-[#D0D5DD] rounded-lg text-sm font-medium text-[#344054] hover:bg-gray-50 transition-colors bg-white shadow-sm">
                  Previous
                </button>
                <button className="px-3 py-2 border border-[#D0D5DD] rounded-lg text-sm font-medium text-[#344054] hover:bg-gray-50 transition-colors bg-white shadow-sm">
                  Next
                </button>
              </div>

              <div className="flex items-center gap-x-2 text-sm text-[#344054]">
                <span>Entries per page:</span>
                <select className="border border-[#D0D5DD] rounded-lg p-1.5 focus:outline-none focus:border-[#00B074] bg-white font-medium">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PaymentReceiptModal
        open={openReceiptModal}
        close={() => setOpenReceiptModal(false)}
      />
    </div>
  );
}

export default PaymentHistory;
